import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Impressora } from '../model/impressora';
import { GlobalService } from './global.service';

@Injectable({
  providedIn: 'root'
})
export class ApiImpressoraService {



  constructor(private http: HttpClient,
    public global: GlobalService) { }
  user = this.global.user;
  pass = this.global.pass;
  auth = btoa(this.user + ':' + this.pass);

  dominio = this.global.dominio;
  impressoraUrl = this.dominio + '/backend/api/v2/impressora';

  listarTodas(): Promise<any> {
    let headers = new HttpHeaders();
    headers = headers.set('Authorization', 'Basic ' + this.auth);
    return this.http.get(`${this.impressoraUrl}/todos`, { headers })
      .toPromise();
  }


  getById(codigo: any): Promise<any> {
    let headers = new HttpHeaders();
    headers = headers.set('Authorization', 'Basic ' + this.auth);
    return this.http.get(`${this.impressoraUrl}/mostrar/${codigo}`, { headers })
      .toPromise();
  }



  excluir(codigo: any): Promise<void> {
    let headers = new HttpHeaders();
    headers = headers.set('Authorization', 'Basic ' + this.auth);
    return this.http.delete(`${this.impressoraUrl}/deletar/${codigo}`, { headers })
      .toPromise()
      .then(() => null);
  }

  save(frete: Impressora) {
    if (frete.id) {
      return this.atualizar(frete);
    } else {
      return this.adicionar(frete);
    }
  }

  adicionar(frete: Impressora): Promise<Impressora> {
    let headers = new HttpHeaders();
    headers = headers.set('Authorization', 'Basic ' + this.auth);
    const body = JSON.stringify(frete);
    return this.http.post<Impressora>(`${this.impressoraUrl}/inserir`, body, { headers })
      .toPromise();

  }


  atualizar(frete: Impressora): Promise<Impressora> {
    let headers = new HttpHeaders();
    headers = headers.set('Authorization', 'Basic ' + this.auth);
    const body = JSON.stringify(frete);
    return this.http.put(`${this.impressoraUrl}/editar`, body, { headers })
      .toPromise()
      .then(response => {
        const pessoaAlterada = response as Impressora;
        return pessoaAlterada;
      });
  }




}
